export class CookieSettings {

    public static get() {
        const cookieSettings = {
            path: '/',
            expires: 365, //days
            domain: undefined as string | undefined
        };

        if (location.hostname !== 'localhost' && location.hostname.indexOf('192.168') !== 0) {
            cookieSettings.domain = location.host.replace('www', '');
        }
        return cookieSettings;
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/CookieSettings.ts